module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/sec02_2_pc_3517424db30c1c63d1b4e1f352f3547a.jpg";